import React from "react";
import "./CompanyAndSharesResult.css";
import { Text, View } from "@react-pdf/renderer";
import ResultsNavigationBar from "../components/ResultsNavigationBar";
import { styles } from "../styles/Slide5Part2Styles";

export function Slide5Part2({
  goodLeaverEventsResult,
  earlyLeaverEventsResult,
  badLeaverEventsResult,
}: {
  goodLeaverEventsResult: {
    tags: string[];
    extra: string;
  };
  earlyLeaverEventsResult: {
    tags: string[];
    extra: string;
  };
  badLeaverEventsResult: {
    tags: string[];
    extra: string;
  };
}) {
  const titles = [
    "Other Good Leaver Events",
    "Other Early Leaver Events",
    "Other Bad Leaver Events",
  ];

  if (
    !goodLeaverEventsResult ||
    !earlyLeaverEventsResult ||
    !badLeaverEventsResult
  ) {
    return <Text>Not all information is filled in for this section</Text>;
  }

  const leaverEvents = [
    goodLeaverEventsResult.tags,
    earlyLeaverEventsResult.tags,
    badLeaverEventsResult.tags,
  ];

  return (
    <View style={styles.backgroundBlue}>
      <ResultsNavigationBar selectIdx={3} />
      <View style={styles.eventsContainer}>
        {titles.map((item, index) => {
          if (leaverEvents[index].includes("Other")) {
            return (
              <View style={styles.eventsBox} key={index}>
                <View style={styles.titleBox}>
                  <Text style={styles.textTitle}>{item}</Text>
                </View>
                <View style={styles.textBox}></View>
              </View>
            );
          }
        })}
      </View>
      ;
    </View>
  );
}
